import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { CheckoutService } from '@pages/checkout-app/checkout.service';

@Directive({
  selector: '[pdqHiddenInGlobaleMode]',
  standalone: false,
})
export class HiddenInGlobaleModeDirective implements OnInit, OnDestroy {
  private subscription?: Subscription;
  private hasView = false;

  constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly checkoutService: CheckoutService,
  ) {}

  ngOnInit(): void {
    this.subscription = this.checkoutService.isGlobaleMode$.subscribe((isGlobaleMode) => {
      if (isGlobaleMode) {
        this.viewContainer.clear();
        this.hasView = false;
      } else if (!this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
